// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app-bottom-sheet-bottom[data-v-7bec3bf8]{width:100%;display:flex;justify-content:center;flex-direction:column;padding:0 10px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
